import React from 'react';
import GenericShipmentRequest from '../GenericShipmentRequest';

const FlexiShipmentRequest = () => (
  <GenericShipmentRequest
    sectionName="Flexi Section"
    sectionKey="Flexi"
    backRoute="/sections/flexi"
  />
);

export default FlexiShipmentRequest;
